export default "__VITE_ASSET__oe_AXlzk__"